import '../../css/mobile/MAddrBookAddPg.css';
import {useTranslation} from "react-i18next";
import React, {useEffect, useRef, useState} from "react";
import axios from '../../services/axiosInstance';
import backIcon from "../../assets/img/backIcon.svg";
import withAuth from "../../auth/UserRouteAuth";
import {BiCaretDown} from "react-icons/bi";
import '../../css/web/UserModalRenew.css';
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";

function MAddrBookAddPg({
                            addrBookModifyBackFn,
                            addrBookModifySt,
                            addrBookModifyBackFn2,
                            addrBookAddSt,
                            book,
                            getBookListFn,
                            selectedShip
                        }) {

    const {t} = useTranslation();
    const [theme] = useTheme();

    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    const [taxid, setTaxid] = useState("");
    const [recname, setRecname] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [city, setCity] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [telnum, setTelnum] = useState("");

    const [nameInputCount, setNameInputCount] = useState(0);
    const [telnumInputCount, setTelnumInputCount] = useState(0);
    const [zipcodeInputCount, setZipcodeInputCount] = useState(0);
    const [address1InputCount, setAddress1InputCount] = useState(0);
    const [address2InputCount, setAddress2InputCount] = useState(0);
    const [address3InputCount, setAddress3InputCount] = useState(0);
    const [cityInputCount, setCityInputCount] = useState(0);

    const [taxidError, setTaxidError] = useState("");
    const [countryError, setCountryError] = useState("");
    const [recnameError, setRecnameError] = useState("");
    const [address1Error, setAddress1Error] = useState("");
    const [address2Error, setAddress2Error] = useState("");
    const [address3Error, setAddress3Error] = useState("");
    const [cityError, setCityError] = useState("");
    const [zipcodeError, setZipcodeError] = useState("");
    const [telnumError, setTelnumError] = useState("");
    const [defaultCkboxSt, setDefaultCkboxSt] = useState(false);

    const postOffice = selectedShip === 'EMS' || selectedShip === 'EMSP' ||
        selectedShip === 'K-Packet' || selectedShip === 'Small-Packet' || selectedShip === 'SEA';
    const SpecialDelivery = selectedShip === 'FedEx' ||selectedShip === 'FedEx-E' ||
        selectedShip === 'UPS' || selectedShip === 'UPS-E' || selectedShip === 'DHL';
    const domesticDelivery = selectedShip === '국내배송';

    const address1Length = postOffice ? 200 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;
    const address2Length = postOffice ? 50 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;
    const address3Length = postOffice ? 50 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;
    const cityLength = postOffice ? 50 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;

    const validTextTaxid = ((e) => {
        const taxidRegex = /^[a-zA-Z0-9\s\-.,]{2,25}$/; /*2~25자*/
        if (!e.target.value || taxidRegex.test(e.target.value)) setTaxidError(false);
        else setTaxidError(true);
        setTaxid(e.target.value);
    })
    const validTextRecname = ((e) => {
        const recnameRegex = /^[a-zA-Z\s]{2,35}/; /*영문 2~35자*/
        if (!e.target.value || recnameRegex.test(e.target.value)) setRecnameError(false);
        else setRecnameError(true);
        setRecname(e.target.value);
    })
    const validTextAddr1 = ((e) => {
        const Addr1Regex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${address1Length}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || Addr1Regex.test(e.target.value)) setAddress1Error(false);
        else setAddress1Error(true);
        setAddress1(e.target.value);
    })
    const validTextAddr2 = ((e) => {
        const Addr2Regex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${address2Length}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || Addr2Regex.test(e.target.value)) setAddress2Error(false);
        else setAddress2Error(true);
        setAddress2(e.target.value);
    })
    const validTextAddr3 = ((e) => {
        const Addr3Regex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${address3Length}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || Addr3Regex.test(e.target.value)) setAddress3Error(false);
        else setAddress3Error(true);
        setAddress3(e.target.value);
    })
    const validTextCity = ((e) => {
        const cityRegex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${cityLength}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || cityRegex.test(e.target.value)) setCityError(false);
        else setCityError(true);
        setCity(e.target.value);
    })
    const validTextZipcode = ((e) => {
        const zipcodeRegex = /^[a-zA-Z\d-\s]{3,10}$/; // 암호화 // 영문 또는 숫자 또는 "-" 로만 가능하게 10자리 이하
        if (!e.target.value || zipcodeRegex.test(e.target.value)) setZipcodeError(false);
        else setZipcodeError(true);
        setZipcode(e.target.value);
    })
    const validTextTelnum = ((e) => {
        const telnumRegex = /^[\d-\s]{5,15}$/; // 암호화 // 숫자 또는 "-" 로만 가능하게 10자리 이하
        if (!e.target.value || telnumRegex.test(e.target.value)) setTelnumError(false);
        else setTelnumError(true);
        setTelnum(e.target.value);
    })

    const [countryList, setCountryList] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({ value: '', label: t(`ordCrLabel`)});
    const [countryShow, setCountryShow] = useState(false);
    const [filteredCountryList, setFilteredCountryList] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const countryRef = useRef(null);

    const toggleCountryShow = () => {
        setCountryShow(prev => !prev);
    };

    const handleCountryChange = (country, event) => {
        event.stopPropagation();
        setSelectedCountry(country);
        setSearchKeyword(country.label);
        setCountryShow(false);
    };

    const countryNameMapping = {
        'USA': 'United States of America',
        '터키': '튀르키예',
    };

    const handleCountrySearch = (event) => {
        const keyword = event.target.value;
        setSearchKeyword(keyword);

        const mappedKeyword = countryNameMapping[keyword.toUpperCase()] || countryNameMapping[keyword] || keyword;

        const filteredCountries = countryList.filter((country) =>
            country.label.toLowerCase().includes(mappedKeyword.toLowerCase())
        );

        setFilteredCountryList(filteredCountries);

        if (!keyword) {
            setSelectedCountry({ value: '', label: t(`ordCrLabel`) });
        }
    };

    const validation = () => {
        let isValue = true;
        if (!selectedCountry.value || selectedCountry.value === t(`ordCrLabel`)) {
            setCountryError(true);
            isValue = false;
        }
        if (selectedCountry.value === "ID" && selectedShip !== 'EMS' && !taxid) {
            setTaxidError(true);
            isValue = false;
        }
        if (!recname) {
            setRecnameError(true);
            isValue = false;
        }
        if (!address1) {
            setAddress1Error(true);
            isValue = false;
        }
        if (selectedCountry.value !== "KR" && !city) {
            setCityError(true);
            isValue = false;
        }
        if (selectedCountry.value !== "KR" && !zipcode) {
            setZipcodeError(true);
            isValue = false;
        }
        if (!telnum) {
            setTelnumError(true);
            isValue = false;
        }
        return isValue;
    }

    const nameInputLengthCheck = (e) => {
        setNameInputCount(e.target.value.length);
    };
    const telnumInputLengthCheck = (e) => {
        setTelnumInputCount(e.target.value.length);
    };
    const zipcodeInputLengthCheck = (e) => {
        setZipcodeInputCount(e.target.value.length);
    };
    const address1InputLengthCheck = (e) => {
        setAddress1InputCount(e.target.value.length);
    };
    const address2InputLengthCheck = (e) => {
        setAddress2InputCount(e.target.value.length);
    };
    const address3InputLengthCheck = (e) => {
        setAddress3InputCount(e.target.value.length);
    };
    const cityInputLengthCheck = (e) => {
        setCityInputCount(e.target.value.length);
    };

    const nameInputRTCheck = (e) => {
        setNameInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };
    const telnumInputRTCheck = (e) => {
        setTelnumInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };
    const zipcodeInputRTCheck = (e) => {
        setZipcodeInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };
    const address1InputRTCheck = (e) => {
        setAddress1InputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };
    const address2InputRTCheck = (e) => {
        setAddress2InputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };
    const address3InputRTCheck = (e) => {
        setAddress3InputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };
    const cityInputRTCheck = (e) => {
        setCityInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const nameValid = (e) => {
        validTextRecname(e)
        nameInputLengthCheck(e);
        nameInputRTCheck(e)
    }

    const getMaxLengthByTelnumCountry = () => {
        if (selectedCountry.value === "US") return 10;
        return 15;
    };

    const currentMaxLengthTelnumDisplay = `${getMaxLengthByTelnumCountry()}`;

    const telnumValid = (e) => {
        const { value } = e.target;

        //미국 숫자만 10자리
        if (selectedCountry.value === "US") {
            if (/^\d{0,10}$/.test(value)) {
                validTextTelnum(e);
                telnumInputLengthCheck(e);
                telnumInputRTCheck(e);
            }
            return;
        }

        if (value.length <= 15) {
            validTextTelnum(e)
            telnumInputLengthCheck(e);
            telnumInputRTCheck(e)
        }
    }

    const getMaxLengthByZipcode = () => {
        if (selectedCountry.value === "US") return 5; // 미국
        if (selectedCountry.value === "CA") return 6; // 캐나다
        return 10;
    };

    const currentMaxLengthZipcodeDisplay = `${getMaxLengthByZipcode()}`;

    const zipcodeValid = (e) => {
        const { value } = e.target;

        //미국 숫자만 5자리
        if (selectedCountry.value === "US") {
            if (/^\d{0,5}$/.test(value)) {
                validTextZipcode(e);
                zipcodeInputLengthCheck(e);
                zipcodeInputRTCheck(e);
            }
            return;
        }

        //캐나다 알파벳&숫자 6자리
        if (selectedCountry.value === "CA") {
            if (/^[a-zA-Z0-9]{0,6}$/.test(value)) {
                validTextZipcode(e);
                zipcodeInputLengthCheck(e);
                zipcodeInputRTCheck(e);
            }
            return;
        }

        if (value.length <= 10) {
            validTextZipcode(e);
            zipcodeInputLengthCheck(e);
            zipcodeInputRTCheck(e);
        }
    };

    const address1Valid = (e) => {
        validTextAddr1(e)
        address1InputLengthCheck(e);
        address1InputRTCheck(e)
    }
    const address2Valid = (e) => {
        validTextAddr2(e)
        address2InputLengthCheck(e);
        address2InputRTCheck(e)
    }
    const address3Valid = (e) => {
        validTextAddr3(e)
        address3InputLengthCheck(e);
        address3InputRTCheck(e)
    }
    const cityValid = (e) => {
        validTextCity(e)
        cityInputLengthCheck(e);
        cityInputRTCheck(e)
    }

    const errorAndSave = (seqnum) => {
        if (validation()) {
            if (seqnum !== undefined) {
                addrBookModify()
            } else {
                addrBookSave();
            }
        }
    }

    const defaultCkbox = (e) => {
        if (e.target.checked) {
            setDefaultCkboxSt(true);
        } else (
            setDefaultCkboxSt(false)
        )
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            if (addrBookModifySt === true) {
                setTaxid(book.taxid)
                setRecname(book.recname);
                const countryData = {
                    value: book.countryDTO.countryCode,
                    label: book.countryDTO.countryNm + '(' + book.countryDTO.countryEngNm + ')'
                };
                setSelectedCountry(countryData);
                setAddress1(book.address1);
                setAddress2(book.address2);
                setAddress3(book.address3);
                setCity(book.city);
                setZipcode(book.zipcode);
                setTelnum(book.telnum);
                setDefaultCkboxSt(book.defaultAddrFl)
            }
        })
        return () => {
            clearTimeout(timer);
        }
    }, [])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (countryRef.current && !countryRef.current.contains(event.target)) {
                setCountryShow(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const selectAllCountry = () => {
        axios.get('/order/selectCountry')
            .then(response => {
                const countries = response.data.map(country => ({
                    value: country.countryCode,
                    label: `${country.countryNm} (${country.countryEngNm})`
                })).sort((a, b) => a.label.localeCompare(b.label));

                setCountryList(countries);
                setFilteredCountryList(countries);
            })
            .catch(error => {
                console.error("Error fetching countries:", error);
            });
    };

    useEffect(() => {
        selectAllCountry();
    }, [])

    const addrBookSave = (() => {
        axios({
            method: 'post',
            url: '/member/addrBookSave',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: {
                addrBookAddSt: addrBookAddSt,
            },
            data: {
                crCode: selectedCountry.value,
                taxid: selectedCountry.value === 'ID' ? taxid : null,
                recname: recname,
                address1: address1,
                address2: address2,
                address3: address3,
                city: city,
                zipcode: zipcode,
                telnum: telnum,
                defaultAddrFl: defaultCkboxSt,
            },
        })
            .then(() => {
                addrBookModifyBackFn2()
                getBookListFn()
            })
    })

    const addrBookModify = (() => {
        axios({
            method: 'post',
            url: '/member/addrBookSave',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: {
                bookSeqnum: book.seqnum
            },
            data: {
                crCode: selectedCountry.value,
                taxid: selectedCountry.value === 'ID' ? taxid : null,
                recname: recname,
                address1: address1,
                address2: address2,
                address3: address3,
                city: city,
                zipcode: zipcode,
                telnum: telnum,
                defaultAddrFl: defaultCkboxSt,
            },
        })
            .then(() => {
                addrBookModifyBackFn()
                getBookListFn()
            })
    })

    const MAddrAddInput = (isEssential,
                           title,
                           value,
                           maxLength,
                           ref,
                           onChange,
                           showLength,
                           length,
                           lengthLimit,
                           showEssential = true,
                           extraClass = "") => {
        const numericTitles = [t('modNbInfo5')];
        const isNumericInput = numericTitles.includes(title);
        return (
            <div className="m-a-addr-add-input-box font-t-cont wd-100pc p-l-7">
                {value.length > 0 &&
                    <div className="m-a-addr-add-input-title">
                        {isEssential && showEssential && <div className="m-a-addr-add-input-essential">* &nbsp;</div>}
                        {title}
                    </div>
                }
                {value.length === 0 && isEssential && showEssential &&
                    <div className="m-a-addr-add-input-essential">* &nbsp;</div>
                }
                <input className={`m-a-addr-add-input wd-80pc ${extraClass}`}
                       value={value} maxLength={maxLength}
                       ref={ref}
                       type={isNumericInput ? "tel" : "text"}
                       inputMode={isNumericInput ? "numeric" : undefined}
                       pattern={isNumericInput ? "[0-9]*" : undefined}
                       placeholder={value.length === 0 ? title : ''}
                       onChange={onChange}/>
                {showLength &&
                    <div className="m-a-addr-add-input-text wd-20pc text-right p-r-5">
                        <div className="m-a-addr-add-input-text highlight"> {length}</div>
                        / {lengthLimit}
                    </div>
                }
            </div>
        )
    }

    return (
        <div className="m-a-addr-book-add-background font-t-cont md-scope" data-theme={theme}>
            <div className='m-a-addr-book-add-background'>
                <div className="m-a-addr-book-add-container">
                    {addrBookModifySt ?
                        <div className="m-a-addr-book-add-header">
                            <img className="m-a-addr-book-add-header-back" src={backIcon} alt={''} onClick={addrBookModifyBackFn}/>
                            <div className="text-center font-t-title p-t-4">{t(`abModiBt`)}</div> {/*배송지수정*/}
                        </div>
                        : addrBookAddSt ?
                            <div className="m-a-addr-book-add-header">
                                <img className="m-a-addr-book-add-header-back" src={backIcon} alt={''} onClick={addrBookModifyBackFn2}/>
                                <div className="font-t-title text-center p-t-4">{t(`abAddBt`)}</div> {/*배송지추가*/}
                            </div>
                            : null
                    }
                    <div className="m-a-addr-book-add-divider"/>
                    <div className="m-a-addr-book-add-content">
                        {/*여기서부터 커스텀 국가셀렉트*/}
                        <div ref={countryRef} className="wd-100pc ht-45 c-point position-relative" onClick={toggleCountryShow}>
                            <div className="order-rec-country-input display-flex flex-row wd-100pc ht-100pc">
                                {selectedCountry.value ? (
                                    <div className="wd-15pc text-center p-l-6 p-t-8">
                                        <div className={`m-l-6 font-s-20 fi fi-${selectedCountry.value.toLowerCase()}`} />
                                    </div>
                                ) : (
                                    <div className="wd-15pc text-center p-l-6 p-t-8">
                                        <div className="wd-29 ht-22 text-center font-s-12 m-0-a country-select-flag">?</div>
                                    </div>
                                )}
                                <input className="country-select-in-input wd-100pc ht-100pc c-point font-s-12 p-l-15"
                                       type="text" placeholder={t(`modSmallMenu3-1`)} autoComplete="nope"
                                       value={searchKeyword || (selectedCountry.value ? selectedCountry.label : '') || (selectedCountry.value ? selectedCountry.label : '')}
                                       onChange={handleCountrySearch} />
                                <i className="wd-15pc text-center align-center-c font-s-20 p-b-2 font-c-darkgrey">
                                    <BiCaretDown />
                                </i>
                            </div>
                            {countryShow && (
                                <div className="country-select-data wd-100pc position-absolute m-t-5">
                                    <div className="country-select-data-child">
                                    {filteredCountryList.map((country, index) => (
                                        <div className="selectCrListBt display-flex c-point p-t-10 p-b-10 p-l-20" key={index}
                                             onClick={(event) => handleCountryChange(country, event)}>
                                            <div className={`font-s-17 m-r-8 fi fi-${country.value.toLowerCase()}`}></div>
                                            <p className="font-s-14">{country.label}</p>
                                        </div>
                                    ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        {countryError &&
                            <div className="m-a-addr-book-add-error">{t(`recCrErr`)}</div>
                        }
                        {/*연락처*/}
                        {MAddrAddInput(true,
                            t(`modNbInfo5`),
                            telnum,
                            15,
                            null,
                            telnumValid,
                            selectedCountry.value !== "KR", telnumInputCount, currentMaxLengthTelnumDisplay)}
                        {selectedCountry.value !== "KR" && telnumError &&
                            <div className="m-a-addr-book-add-error">{t("recTellErr")}</div>
                        }
                        {/*우편번호*/}
                        {MAddrAddInput(true,
                            t(`modNbInfo8`),
                            zipcode,
                            10,
                            null,
                            zipcodeValid,
                            true, zipcodeInputCount, currentMaxLengthZipcodeDisplay)}
                        {zipcodeError &&
                            <div className="m-a-addr-book-add-error">
                                {t("recZipErr")}
                            </div>
                        }
                        {selectedCountry.value === "ID" ?
                            <>
                                {MAddrAddInput(true,
                                    'Tax ID',
                                    taxid,
                                    25,
                                    null,
                                    validTextTaxid,
                                    false, 0, 0)}
                            </>
                            : null}
                        {taxidError &&
                            <div className="m-a-addr-book-add-error">{t(`recTaxIdErr`)}</div>
                        }
                        {MAddrAddInput(true,
                            t(`joinLabel5`),
                            recname,
                            35,
                            null,
                            nameValid,
                            selectedCountry.value !== "KR", nameInputCount, 35)}
                        {selectedCountry.value !== "KR" && recnameError &&
                            <div className="m-a-addr-book-add-error">{t(`recNmErr`)}</div>
                        }
                        {MAddrAddInput(true,
                            selectedCountry.value === "KR" ? t(`modSmallMenu14`) : t(`modSmallMenu7`),
                            address1,
                            selectedCountry.value !== "KR" ? address1Length : null,
                            null,
                            address1Valid,
                            selectedCountry.value !== "KR", address1InputCount, address1Length)}
                        {selectedCountry.value !== "KR" && address1Error &&
                            <div className="m-a-addr-book-add-error">
                                {`${t("recAddrErr1")} 2~${address1Length}${t("recAddrErr2")}`}
                            </div>
                        }
                        {selectedCountry.value !== "KR" && (
                            <>
                                {/*주소2*/}
                                {MAddrAddInput(true,
                                    t(`modSmallMenu8`),
                                    address2,
                                    address2Length,
                                    null,
                                    address2Valid,
                                    true, address2InputCount, address2Length, false, "p-l-9")}
                                {address2Error &&
                                    <div className="m-a-addr-book-add-error">
                                        {`${t("recAddrErr1")} 2~${address2Length}${t("recAddrErr2")}`}
                                    </div>
                                }
                                {/*주소3*/}
                                {MAddrAddInput(true,
                                    t(`modSmallMenu9`),
                                    address3,
                                    address3Length,
                                    null,
                                    address3Valid,
                                    true, address3InputCount, address3Length, false, "p-l-9")}
                                {address3Error &&
                                    <div className="m-a-addr-book-add-error">
                                        {`${t("recAddrErr1")} 2~${address3Length}${t("recAddrErr2")}`}
                                    </div>
                                }
                                {/*도시명*/}
                                {MAddrAddInput(true,
                                    t(`modSmallMenu10`),
                                    city,
                                    cityLength,
                                    null,
                                    cityValid,
                                    true, cityInputCount, cityLength)}
                                {cityError &&
                                    <div className="m-a-addr-book-add-error">
                                        {`${t("recAddrErr1")} 2~${cityLength}${t("recAddrErr2")}`}
                                    </div>
                                }
                            </>
                        )}
                        <div className="m-a-addr-book-add-default">
                            <input id="defaultAddrCkbox" type="checkbox" checked={defaultCkboxSt} onChange={defaultCkbox} className="admin-input-chkBox"/>
                            {t(`ordDfAddr`)} {/*기본배송지*/}
                        </div>
                    </div>
                    <div className="m-a-addr-book-add-pg-bottom">
                        <button className="admin-btn-C wd-100pc ht-40" onClick={() => addrBookAddSt === true ? errorAndSave() : errorAndSave(book.seqnum)}>{t(`saveBt`)}</button>
                        {/*저장*/}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withAuth(MAddrBookAddPg)
